import LegalbirdIoModal from "../../Modal/LegalbirdIoModal";
import ButtonLoading from "../../Button/ButtonLoading";
import React, { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { createResource } from "../../../services/ReactQuery/reactQueryService";

import { ProductUnion } from "../../../types/ProductUnion";

type CourtAppointmentModalProps = {
  product: ProductUnion;
  open: boolean;
  handleClose: Function;
  refreshPage?: Function;
};

function CourtAppointmentModal({ product, open, handleClose, refreshPage = () => {} }: CourtAppointmentModalProps) {
  const [isLoading, setIsLoading] = useState(false);
  const createMutation = useMutation({
    mutationFn: createResource
  });

  if (!product) {
    return null;
  }

  const createCourtAppointment = () => {
    setIsLoading(true);
    createMutation.mutateAsync({ uri: "court_appointments", data: { caseId: product.id } }).then(() => {
      setIsLoading(false);
      refreshPage();
      handleClose();
    });
  };

  return (
    <LegalbirdIoModal
      handleClose={handleClose}
      open={open}
      title={"Termin ohne Ladung erstellen"}
      submitButton={
        <ButtonLoading onClick={createCourtAppointment} color="primary" variant={"contained"} isLoading={isLoading}>
          Termin ohne Ladung erstellen
        </ButtonLoading>
      }
    >
      <p className={"center"}>
        Sollte für den Gerichtstermin keine Ladung vorliegen oder muss der Termin kurzfristig ausgeschrieben werden, so
        kann das Terminfenster hier aktiviert werden.
        <br />
        Bitte beachten: Eine nachträglich hochgeladene Ladung kann diesem Termin nicht zugeordnet werden!
      </p>
    </LegalbirdIoModal>
  );
}

export default CourtAppointmentModal;
